import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormPreviewHeaderContainer } from './form-preview-header';
import { appHeaderHeight, AudioProvider, FakeBlurOverlay, formHeaderHeight, PinLayout } from '@lib/common';
import { PinnedQuestionComponent, SectionV2Preview, useConfirmSubmissionAudioModal } from '@module/form-components';
import styled from 'styled-components';
import { SectionSummaryColumnContainer } from './section-summary-column';
import { ColorModeProvider, ThemeProvider } from '@xstyled/styled-components';
import { useTheme } from '@lib/common';
import { useFormPreview } from './hooks';
import { Skeleton } from 'antd';
import { createSectionPreviewDisplay, SectionPreviewContainer } from './section';
import { resetFormPreviewAppState } from '../../redux/app.reducer';
import { QuestionReleases, Questions } from '@module/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var paddingTopOfSectionSummary = 64;
export var marginBetweenItemsSectionSummary = 16;
var StyledContent = styled.div.withConfig({
  displayName: "form-previewcontainer__StyledContent",
  componentId: "sc-12aicck-0"
})(["display:flex;flex-direction:column;min-height:100%;width:100%;float:right;--question-scroll-margin:80px;"]);

var FormPreview = function FormPreview(_ref) {
  var formId = _ref.formId,
      formPreviewLabels = _ref.formPreviewLabels,
      isModal = _ref.isModal,
      heightModal = _ref.heightModal,
      isHideAudioModal = _ref.isHideAudioModal,
      isHiddenCountDown = _ref.isHiddenCountDown,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'normal-form' : _ref$type,
      _ref$showCorrectAnswe = _ref.showCorrectAnswer,
      showCorrectAnswer = _ref$showCorrectAnswe === void 0 ? true : _ref$showCorrectAnswe,
      _ref$showExplanation = _ref.showExplanation,
      showExplanation = _ref$showExplanation === void 0 ? true : _ref$showExplanation;
  var dispatch = useDispatch();
  var page = useSelector(function (state) {
    return state.formPreviewApp;
  });

  var _useState = useState(null),
      selectedQuestionId = _useState[0],
      setSelectedQuestionId = _useState[1];

  var onSelectQuestion = useCallback(function (questionId) {
    setSelectedQuestionId(questionId);
  }, []);
  useEffect(function () {
    return function () {
      dispatch(resetFormPreviewAppState());
    };
  }, [dispatch]);

  var _useFormPreview = useFormPreview({
    formId: formId,
    formPreviewLabels: formPreviewLabels,
    type: type,
    showCorrectAnswer: showCorrectAnswer,
    showExplanation: showExplanation
  }),
      pinnedSectionId = _useFormPreview.pinnedSectionId,
      pinnedQuestionId = _useFormPreview.pinnedQuestionId,
      pinStatus = _useFormPreview.pinStatus,
      setPinStatus = _useFormPreview.setPinStatus,
      onCancelPin = _useFormPreview.onCancelPin,
      onPinQuestion = _useFormPreview.onPinQuestion,
      onPinSection = _useFormPreview.onPinSection,
      renderPinnedQuestionOrSection = _useFormPreview.renderPinnedQuestionOrSection,
      sectionSummaries = _useFormPreview.sectionSummaries,
      updateSelectedSection = _useFormPreview.updateSelectedSection;

  var questionsBySection = useMemo(function () {
    var grouped = new Map();
    if (!(page !== null && page !== void 0 && page.form) || !page.questions) return grouped;
    var sections = sectionSummaries.length ? sectionSummaries : page.form.sections;
    var sortedQuestions = type === 'form-release' ? QuestionReleases.sortQuestionsWithIndexBySectionsOrder(page.questions, sections) : Questions.sortQuestionsWithIndexAndSection(page.questions, sections.map(function (section) {
      return section.id.toString();
    }));
    sortedQuestions.forEach(function (question) {
      var _grouped$get;

      var sectionId = question.sectionId.toString();
      var sectionQuestions = (_grouped$get = grouped.get(sectionId)) !== null && _grouped$get !== void 0 ? _grouped$get : [];
      sectionQuestions.push(question);
      grouped.set(sectionId, sectionQuestions);
    });
    return grouped;
  }, [page === null || page === void 0 ? void 0 : page.form, page === null || page === void 0 ? void 0 : page.questions, sectionSummaries, type]);
  var audioConfirmModalLabels = formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.useSubmissionAudioModalLabels;

  var _useConfirmSubmission = useConfirmSubmissionAudioModal({
    sections: sectionSummaries,
    labels: audioConfirmModalLabels
  }),
      hasConfirmedAudio = _useConfirmSubmission.hasConfirmedAudio,
      submissionHasAudio = _useConfirmSubmission.submissionHasAudio,
      SubmissionAudioConfirmModal = _useConfirmSubmission.SubmissionAudioConfirmModal;

  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var renderPinnedItem = function renderPinnedItem() {
    var _formPreviewLabels$se, _formPreviewLabels$pr;

    var pinnedData = renderPinnedQuestionOrSection();
    if (!pinnedData) return null;
    var pinnedQuestion = pinnedData.pinnedQuestion,
        pinnedQuestionIndex = pinnedData.pinnedQuestionIndex,
        isSectionPinned = pinnedData.isSectionPinned,
        questionLabel = pinnedData.questionLabel,
        section = pinnedData.selectedSection,
        selectedSectionIndex = pinnedData.selectedSectionIndex;
    var displaySection = isSectionPinned ? createSectionPreviewDisplay(section, formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.presentation) : null;

    var sectionLabel = _objectSpread(_objectSpread({
      audio: formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : (_formPreviewLabels$se = formPreviewLabels.section) === null || _formPreviewLabels$se === void 0 ? void 0 : _formPreviewLabels$se.audio
    }, formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.section), formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : (_formPreviewLabels$pr = formPreviewLabels.presentation) === null || _formPreviewLabels$pr === void 0 ? void 0 : _formPreviewLabels$pr.sectionDisplay);

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [pinnedQuestion && /*#__PURE__*/_jsx(PinnedQuestionComponent, {
        question: pinnedQuestion,
        index: pinnedQuestionIndex,
        label: questionLabel
      }), isSectionPinned && displaySection && /*#__PURE__*/_jsx(SectionV2Preview, {
        section: displaySection,
        sectionLabel: sectionLabel,
        sectionDisplayIndex: selectedSectionIndex,
        titleVariant: "compact",
        hidePinButton: true,
        audioPlayerLabels: formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.audioPlayer,
        readonly: true,
        disableAudioRules: true
      })]
    });
  };

  var renderSectionQuestionColumn = function renderSectionQuestionColumn() {
    var _page$isLoadingForm, _page$isLoadingQuesti;

    var isLoadingForm = (_page$isLoadingForm = page === null || page === void 0 ? void 0 : page.isLoadingForm) !== null && _page$isLoadingForm !== void 0 ? _page$isLoadingForm : false;
    var isLoadingQuestions = (_page$isLoadingQuesti = page === null || page === void 0 ? void 0 : page.isLoadingQuestions) !== null && _page$isLoadingQuesti !== void 0 ? _page$isLoadingQuesti : false;

    if (isLoadingForm || isLoadingQuestions || sectionSummaries.length === 0) {
      return /*#__PURE__*/_jsxs(StyledContent, {
        style: {
          padding: '24px'
        },
        children: [/*#__PURE__*/_jsx(Skeleton, {
          active: true,
          paragraph: {
            rows: 3
          }
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Skeleton, {
          active: true,
          paragraph: {
            rows: 10
          }
        })]
      });
    }

    return /*#__PURE__*/_jsx(StyledContent, {
      children: sectionSummaries === null || sectionSummaries === void 0 ? void 0 : sectionSummaries.map(function (section, index) {
        var _questionsBySection$g;

        return /*#__PURE__*/_jsx(SectionPreviewContainer, {
          showCorrectAnswer: showCorrectAnswer,
          showExplanation: showExplanation,
          isApplySectionDisplayType: false,
          index: index,
          section: section,
          questions: (_questionsBySection$g = questionsBySection.get(section.id.toString())) !== null && _questionsBySection$g !== void 0 ? _questionsBySection$g : [],
          selectedQuestionId: selectedQuestionId,
          onSelectQuestion: onSelectQuestion,
          onPin: onPinSection,
          pinnedSectionId: pinnedSectionId,
          onCancelPin: onCancelPin,
          labels: formPreviewLabels.section,
          onPinQuestion: onPinQuestion,
          pinnedQuestionId: pinnedQuestionId,
          formPreviewLabels: formPreviewLabels
        }, section.id.toString());
      })
    });
  };

  var renderSectionSummaryColumn = function renderSectionSummaryColumn() {
    return /*#__PURE__*/_jsx(SectionSummaryColumnContainer, {
      isModal: isModal,
      heightModal: heightModal,
      onCancelPin: onCancelPin,
      sectionLabels: formPreviewLabels.sectionSummary,
      countDownLabels: formPreviewLabels.countDownTimer,
      updateSelectedSection: updateSelectedSection,
      onSelectQuestion: onSelectQuestion,
      isHiddenCountDown: isHiddenCountDown
    });
  };

  var renderContent = function renderContent() {
    if (submissionHasAudio && !hasConfirmedAudio && !isModal && !isHideAudioModal) {
      return /*#__PURE__*/_jsx(FakeBlurOverlay, {
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormPreviewHeaderContainer, {}), /*#__PURE__*/_jsx(PinLayout, {
            renderPinColumn: /*#__PURE__*/_jsx("div", {
              children: "Loading..."
            }),
            renderMainContentColumn: /*#__PURE__*/_jsx(StyledContent, {}),
            renderSummaryColumn: /*#__PURE__*/_jsx("div", {}),
            pinStatus: pinStatus,
            setPinStatus: setPinStatus,
            onClosePinnedItem: onCancelPin,
            pageHeaderHeight: appHeaderHeight + formHeaderHeight
          })]
        })
      });
    }

    var content = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormPreviewHeaderContainer, {}), /*#__PURE__*/_jsx(PinLayout, {
        renderPinColumn: renderPinnedItem(),
        renderMainContentColumn: renderSectionQuestionColumn(),
        renderSummaryColumn: renderSectionSummaryColumn(),
        pinStatus: pinStatus,
        setPinStatus: setPinStatus,
        onClosePinnedItem: onCancelPin,
        pageHeaderHeight: isModal ? formHeaderHeight : appHeaderHeight + formHeaderHeight,
        heightScreen: isModal && heightModal
      })]
    });

    return content;
  };

  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/_jsx(ColorModeProvider, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [!isModal && !isHideAudioModal && /*#__PURE__*/_jsx(SubmissionAudioConfirmModal, {}), renderContent()]
      })
    })
  });
};

export var FormPreviewContainer = function FormPreviewContainer(_ref2) {
  var formId = _ref2.formId,
      formPreviewLabels = _ref2.formPreviewLabels,
      _ref2$isModal = _ref2.isModal,
      isModal = _ref2$isModal === void 0 ? true : _ref2$isModal,
      _ref2$isHideAudioModa = _ref2.isHideAudioModal,
      isHideAudioModal = _ref2$isHideAudioModa === void 0 ? false : _ref2$isHideAudioModa,
      _ref2$heightModal = _ref2.heightModal,
      heightModal = _ref2$heightModal === void 0 ? '100vh' : _ref2$heightModal,
      isHiddenCountDown = _ref2.isHiddenCountDown,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'normal-form' : _ref2$type,
      _ref2$showCorrectAnsw = _ref2.showCorrectAnswer,
      showCorrectAnswer = _ref2$showCorrectAnsw === void 0 ? true : _ref2$showCorrectAnsw,
      _ref2$showExplanation = _ref2.showExplanation,
      showExplanation = _ref2$showExplanation === void 0 ? true : _ref2$showExplanation;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(AudioProvider, {
      children: /*#__PURE__*/_jsx(FormPreview, {
        formId: formId,
        formPreviewLabels: formPreviewLabels,
        heightModal: heightModal,
        isModal: isModal,
        isHiddenCountDown: isHiddenCountDown,
        isHideAudioModal: isHideAudioModal,
        type: type,
        showCorrectAnswer: showCorrectAnswer,
        showExplanation: showExplanation
      })
    })
  });
};